import { ListingRichTextHolder } from './ListingRichText.styled';

type Props = {
  content: string;
};

export function ListingRichText({ content }: Props) {
  return (
    <ListingRichTextHolder dangerouslySetInnerHTML={{ __html: content }} />
  );
}
